module.exports = __webpack_public_path__ + "assets/img/ic-service-wrapper-white.145b698d.svg";